import classes from './RichText.module.css';

type RichTextProps = {
  html: string;
};

function RichText({ html }: RichTextProps) {
  return <div className={classes.richtextContainer} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default RichText;
